import * as api from '../api'

export const setSubscriptionToEdit = ({ commit }, sub) => {
  commit('SET_SUBSCRIPTION_EDIT', sub)
}

export const loadPlans = async ({ commit, dispatch }, data) => {
  let allPlans = []
  try {
    const res = await api.fetchPlans()
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      allPlans = await dispatch('checkNested', { obj: res, props: ['data', 'results'] })
    }
    commit('SET_AVAILABLE_PLANS', allPlans)
    return allPlans
  } catch (err) {
    console.log(await dispatch('checkNested', { obj: err, props: ['response', 'data'] }))
  }
}

export const loadCoupon = async ({ commit, dispatch, state }, couponCode) => {
  try {
    const res = await api.findCoupon(couponCode)
    return await dispatch('checkNested', { obj: res, props: ['data'] })
  } catch (err) {
    console.log(await dispatch('checkNested', { obj: err, props: ['response', 'data'] }))
  }
}

export const loadSubscriptions = async ({ commit, dispatch }, data) => {
  try {
    const res = await api.fetchMySubscriptions()
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      const subscriptions = await dispatch('checkNested', { obj: res, props: ['data', 'results'] })
      commit('SET_MY_SUBSCRIPTIONS', subscriptions)
      commit('USERS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
      return subscriptions
    }
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const loadActiveSubscriptions = async ({ commit, dispatch }) => {
  try {
    const res = await api.fetchActiveSubscriptions()
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      const subscriptions = await dispatch('checkNested', { obj: res, props: ['data', 'results'] })
      commit('SET_ACTIVE_SUBSCRIPTIONS', subscriptions)
      return subscriptions
    }
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const loadActiveUserSubscriptions = async ({ commit, dispatch }, data) => {
  try {
    const res = await api.fetchActiveUserSubscriptions(data)
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      const subscriptions = await dispatch('checkNested', { obj: res, props: ['data'] })
      commit('SET_ACTIVE_USER_SUBSCRIPTIONS', subscriptions)
      return subscriptions
    }
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const subscribe = async ({ commit, dispatch }, data) => {
  try {
    const res = await api.postNewSubscription(data)
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      const subscription = res.data
      commit('ADD_SUBSCRIPTION', subscription)
      return subscription
    }
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const subscribeClient = async ({ commit, dispatch, getters }, data) => {
  try {
    const user = [getters.newUser.data]
    const currentUserId = getters.getMyInfo._id
    const group = getters.activeGroup

    await api.postNewClientSubscription({ currentUser: currentUserId, users: user, payment: data, group })
    return { status: 'active' }
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const subscribeBulkClients = async ({ commit, dispatch, getters }, data) => {
  try {
    const users = getters.users.data
    const currentUserId = getters.getMyInfo._id
    const group = getters.activeGroup

    await api.postNewClientSubscription({ currentUser: currentUserId, users, payment: data, group })
    return { status: 'active' }
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const changeSubscriptionPayment = async ({ commit, dispatch }, data) => {
  try {
    const res = await api.changeSubscription(data.subscription, data)
    const subscription = await dispatch('checkNested', { obj: res, props: ['data'] })
    commit('CHANGE_SUBSCRIPTION', subscription)
    return subscription
  } catch (err) {
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const cancelSubscription = async ({ commit, dispatch }, activeSubscription) => {
  try {
    const res = await api.deleteSubscription(activeSubscription.id)
    const subscription = await dispatch('checkNested', { obj: res, props: ['response', 'data'] })
    commit('REMOVE_SUBSCRIPTION', subscription)
    commit('TOAST_SUBSCRIPTION', 'Subscription canceled!')
    return subscription
  } catch (err) {
    console.log(err)
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const loadPayments = async ({ commit, dispatch }, subscription) => {
  try {
    const res = await api.fetchMyPayments({subscription: subscription})
    const statusString = res.status.toString()
    if (statusString.charAt(0) === '2') {
      const payments = await dispatch('checkNested', { obj: res, props: ['data', 'results'] })
      commit('SET_MY_PAYMENTS', payments)
      return payments
    }
  } catch (err) {
    console.log(err)
    throw await dispatch('checkNested', { obj: err, props: ['response', 'data'] })
  }
}

export const resetUserSubscriptions = async ({ commit }) => {
  commit('SET_ACTIVE_USER_SUBSCRIPTIONS')
}



// WEBPACK FOOTER //
// ./src/app/store/subscriptions/actions.js